import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import background from "assets/images/registerImage.png";
import backgroundMobile from "assets/images/registerMobile.png";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(0),
      height: "100%",
      width: "100%",
      background: "#fff",
      display: "flex",
      justifyContent: "center",
      "@media(max-width: 768px)": {},
      "@media(max-width: 425px)": {
        flexDirection: "column",
        justifyContent: "inherit",
      },
    },
    papsers: {
      width: "40%",
      backgroundImage: `url(${background})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      margin: theme.spacing(0),
      "@media(max-width: 768px)": {
        display: "flex",
      },
      "@media(max-width: 425px)": {
        width: "100%",
        display: "flex",
        height: "34%",
        backgroundImage: `url(${backgroundMobile})`,
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        padding: "61px",
        "& strong": {
          fontFamily: "Montserrat",
          fontSize: "24px",
          fontWeight: "900",
          color: "#fff",
          fontStretch: "normal",
          fontStyle: "normal",
          lineHeight: "1.25",
          letterSpacing: "normal",
          textAlign: "left",
        },
        "& a": {
          color: "#3bccf6",
          padding: "12px",
        },
      },
    },
    buttonError:{
      textAlign: "center",
      background: theme.palette.primary.main,
      color: "#fff",
      borderRadius: 6,
      width: "150px"
    },
    overalyText: {
      "@media(min-width: 768px)": {
        color: "#fff",
        height: "15.25rem",
        width: "40%",
        justifyContent: "left",
        position: "fixed",
        bottom: "4.8rem",
        left: "1rem",
        fontFamily: "Montserrat",
        fontSize: 36.5,
        fontWeight: 600,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        textAlign: "left",
      },
      "@media(max-width: 425px)": {},
    },
    surlign: {
      color: "#3bccf6",
      position: "absolute",
      fontFamily: "Montserrat",
    },
    footerImg: {
      position: "fixed",
      bottom: "0.5rem",
      left: "25rem",
      backgroundColor: "transparent",
      border: "none",
      "@media(max-width: 425px)": {
        display: "none",
      },
    },
    register: {
      width: "60%",
      marginLeft: "auto",
      marginRight: "auto",
      backgroundSize: "cover",
      "@media(max-width: 616px)": {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        background: "#fff",
      },
      "@media(max-width: 425px)": {
        width: "100%",
        display: "flex",
      },
    },
    container: {
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
      justifyContent: "center",
      justifyItems: "center",
      flexDirection: "column",
      "@media(max-width: 425px)": {
        backgroundColor: "#fff",
        width: "100%",
      },
    },
    group: {
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: "4%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      "@media(max-width: 425px)": {},
    },
    imgDiv: {
      marginLeft: "auto",
      marginRight: "auto",
      "@media(max-width: 425px)": {
        width: "100%",
        height: "24px",
        "& img": {
          height: "24px",
        },
      },
    },
    title: {
      marginRight: "auto",
      display: "flex",
      textAlign: "center",
      flexDirection: "column",
      fontFamily: "Montserrat",
      color: theme.palette.primary.main,
      padding: theme.spacing(2),
      fontWeight: 900,
      fontSize: 42,
      "@media(max-width: 425px)": {
        fontSize: "24px",
        fontFamily: "Montserrat",
        fontWeight: "bold",
        padding: "9px",
        marginLeft: "79px",
      },
    },
    form: {
      display: "flex",
      flexDirection: "column",
      fontFamily: "Montserrat",
      padding: theme.spacing(2),
      "& .MuiTextField-root, .MuiFormControl-root ": {
        margin: theme.spacing(1.5),
        width: "45ch",
        borderRaduis: 4.7,
        "@media(max-width: 768px)": {
          width: "20,5rem",
        },
        "@media(max-width: 425px)": {
          width: "87%",
          display: "flex",
          padding: "8px",
        },
      },
    },
    buttons: {
      width: "45ch",
      display: "flex",
      fontFamily: "Montserrat",
      paddingTop: "50px",
      paddingLeft: "12px",
      marginRight: "auto",
      justifyContent: "space-between",
      "@media(max-width: 768px)": {
        width: "20rem",
      },
      "@media(max-width: 425px)": {
        width: "100%",
        alignItems: "center",
        borderRadius: "4px",
        justifyContent: "space-between",
        fontSize: "14px",
        fontFamily: "Montserrat",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: " normal",
        letterSpacing: "normal",
        display: "inline-flex",
        padding: "37px",
        marginTop: "2px",
      },
    },
    log: {
      background: theme.palette.primary.main,
      width: "150px",
      color: "#fff",
      fontSize: 16.8,
      borderRadius: 6,
      "@media(max-width: 425px)": {},
    },
    back: {
      color: "#399ebf",
      background: "#cfecf8",
      borderColor: "#cfecf8",
      borderRadius: 6,
      "@media(max-width: 425px)": {},
    },
    socials: {
      width: "45ch",
      display: "flex",
      marginTop: 10,
      justifyContent: "space-between",
      marginLeft: "auto",
      marginRight: "auto",
    },
    icon: {
      marginTop: "auto",
      marginBottom: "auto",
      padding: 5,
    },
    text: {
      marginTop: "auto",
      marginBottom: "auto",
      fontFamily: "Montserrat",
    },
    error: {
      margin: "auto",
      marginTop: "auto",
      marginBottom: "auto",
      color: "red",
      paddingBottom: "0.7em",
      fontFamily: "Montserrat",
    },
    field: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "#fff",
      borderRadius: 4,
      fontFamily: "Montserrat",
      width: 490,
      height: 50,
      marginTop: 24,
      marginBottom: 16,
      "@media(max-width: 425px)": {
        width: "100%",
      },
    },
    typography: {
      "@media(min-width: 768px)": {
        marginLeft: "15%",
        justifyContent: "center",
      },
    },
    stepstyle: {
      width: "100%",
    },
  })
);
